import {Component, ChangeDetectionStrategy} from '@angular/core';
import { DatePipe } from '@angular/common';
import {UserEventService} from '../../../services/user-event/user-event.service';
import {UserEvent} from '../../../models/user-event';
import {DialogService} from '../../../services/dialog/dialog.service';
import {Dialog} from '../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../interfaces/dialog/dialog-params';
import {Paginator} from '../../../tools/pagination/paginator';
import {PaginatorComponent} from '../paginator/paginator.component';
import {TableSorter} from '../../../tools/table-sorter/table-sorter';
import {TableSorterDirective} from '../../../directives/table-sorter/table-sorter.directive';
import {TableSorterHeaderDirective} from '../../../directives/table-sorter/table-sorter-header.directive';

@Component({
  imports: [
    DatePipe,
    PaginatorComponent,
    TableSorterDirective,
    TableSorterHeaderDirective
],
  templateUrl: './user-event-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-event-modal.component.scss'
})
export class UserEventModalComponent implements Dialog {

  eventKey!: string;
  title: string = 'Logs';

  paginator = new Paginator(5);
  tableSorter: TableSorter = new TableSorter('createdAt', 'desc');

  userEvents: UserEvent[] = [];
  loaded: boolean = false;
  expandedUserEvent: UserEvent | null = null;

  constructor(
    private dialog: DialogService,
    private userEventService: UserEventService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.class = 'modal-lg';
    this.eventKey = params.data.key;
    if (params.data.title) {
      this.title = params.data.title;
    }

    this.fetchAll();
  }

  fetchAll(): void {
    this.loaded = false;

    this.userEventService.findAll({eventKey: this.eventKey}, this.paginator, this.tableSorter).subscribe((userEvents: UserEvent[]) => {
      this.userEvents = userEvents;

      this.loaded = true;
    });
  }

  toggleData(userEvent: UserEvent): void {
    if (this.expandedUserEvent === userEvent) {
      this.expandedUserEvent = null;
    } else {
      this.expandedUserEvent = userEvent;
    }
  }

  hasData(userEvent: UserEvent): boolean {
    return !!userEvent.data;
  }

  isExpandedData(userEvent: UserEvent): boolean {
    return this.expandedUserEvent === userEvent;
  }

  getData(userEvent: UserEvent): string {
    return JSON.stringify(userEvent.data, null, 2);
  }
}
